import React, { useState } from 'react';
import {
    Box,
    IconButton,
    Typography,
    Autocomplete,
    TextField,
    Button,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    ClickAwayListener
} from '@mui/material';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import ImageSelector from '../ImageSelector';
import { IMAGE_SELECTOR_IN_QUIZ_QUESTION, LOCK_ASPECT_QUESTION } from '../../Const';
import AudioPlayer from '../AudioPlayer';

export default function OptionFactSelectedList({ selectedList, onUpdateSelectedList, disDatSelection }) {
    const [editingIndex, setEditingIndex] = useState(null);
    const OPTION_FACT_TYPE_TEXT = 0;
    const OPTION_FACT_TYPE_IMAGE = 1;
    const OPTION_FACT_TYPE_AUDIO = 2;

    const {
        type = '',
        entity1 = null,
        entity2 = null
    } = disDatSelection || {};



    const getQvSource = (type) => {


        switch (type) {
            case 'MUSICAL_GROUP_ALBUM_VS_ALBUM':
            case 'MUSICIAN_ALBUM_VS_ALBUM':
                return 'MUSICBRAINZ';
            case 'CUSTOM':
                return 'QUIZMYDAY';
            default:
                return 'WIKIDATA';
        }
    };

    const qvSource = getQvSource(type);


    const handleAddCustomFact = () => {
        const newFact = {
            ofqo: {
                messageValues: [''],
                selectedMessageTokenIndex: 0,
                correctOption: {
                    qv: {
                        quizzlerObject: entity1 || {}
                    }
                },
                messageKey: null
            }
        };
        onUpdateSelectedList([...selectedList, newFact]);
        setEditingIndex(selectedList.length);
    };

    const handleAddCustomImage = () => {
        const newFact = {
            ofqo: {
                messageValues: [''],
                selectedMessageTokenIndex: 0,
                correctOption: {
                    qv: {
                        quizzlerObject: entity1 || {}
                    }
                },
                messageKey: null,
                messageArgs: ['????']

            }
        };
        onUpdateSelectedList([...selectedList, newFact]);
        setEditingIndex(selectedList.length);
    };

    const handleShuffle = () => {
        const shuffled = [...selectedList]
            .map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
        onUpdateSelectedList(shuffled);
    };

    const handleDelete = (index) => {
        const updated = selectedList.filter((_, i) => i !== index);
        onUpdateSelectedList(updated);
    };

    const handleMove = (index, direction) => {
        const updated = [...selectedList];
        const targetIndex = index + direction;
        if (targetIndex < 0 || targetIndex >= updated.length) return;
        const temp = updated[targetIndex];
        updated[targetIndex] = updated[index];
        updated[index] = temp;
        onUpdateSelectedList(updated);
    };

    return (
        <Box sx={{ height: '90%', overflowY: 'auto', pr: 1 }}>
            <Box sx={{ mb: 3, mt: 4, px: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap', textAlign: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                    Matchup: <Typography component="span" variant="h5">{entity1?.label || '—'} vs {entity2?.label || '—'}</Typography>
                </Typography>
                <IconButton onClick={handleShuffle} title="Shuffle Order"><ShuffleIcon /></IconButton>

            </Box>

            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>

                <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddCustomFact}>Add Custom Fact</Button>
                <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddCustomImage}>Add Custom Image</Button>
            </Box>

            {selectedList.map((of, index) => {
                const messageValues = of.ofqo.messageValues;
                const selectedIndex = of.ofqo.selectedMessageTokenIndex;
                let inputRef = null;


                const handleEditClick = (index) => {

                    if (editingIndex === index) {
                        commitAutocompleteEdit();
                    }
                    else {
                        setEditingIndex(prevIndex => (prevIndex === index ? null : index));
                    }
                };


                const getOfType = () => {

                    const arg = of.ofqo.messageArgs?.[0];

                    if (arg && arg.startsWith('??')) {
                        return OPTION_FACT_TYPE_IMAGE;
                    } else if (arg && arg.startsWith('<<')) {
                        return OPTION_FACT_TYPE_AUDIO;
                    } else {
                        return OPTION_FACT_TYPE_TEXT;
                    }


                }

                const ofType = getOfType();


                const handleAltChange = () => {

                }

                const handleImageSelected = (imd) => {


                    const updated = [...selectedList];
                    updated[index] = {
                        ...updated[index],
                        ofqo: {
                            ...updated[index].ofqo,
                            imd: imd
                        }
                    };

                    onUpdateSelectedList(updated);

                }




                const commitAutocompleteEdit = () => {
                    const value = inputRef?.value?.trim();
                    if (!value) {
                        setEditingIndex(null);
                        return;
                    }
                    const existingIndex = messageValues.indexOf(value);
                    const updated = [...selectedList];
                    updated[index] = {
                        ...updated[index],
                        ofqo: {
                            ...updated[index].ofqo,
                            messageValues: existingIndex !== -1 ? messageValues : [...messageValues, value],
                            selectedMessageTokenIndex: existingIndex !== -1 ? existingIndex : messageValues.length
                        }
                    };
                    onUpdateSelectedList(updated);
                    setEditingIndex(null);
                };

                return (
                    <Box key={index} sx={{ borderBottom: '1px solid #ddd' }}>
                        <ClickAwayListener onClickAway={() => editingIndex === index && commitAutocompleteEdit()}>
                            <Box sx={{ py: 1, px: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: '30px', textAlign: 'right', pr: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'gray' }}>#{index + 1}</Typography>
                                    </Box>
                                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                        {ofType === OPTION_FACT_TYPE_TEXT && <Box>
                                            {editingIndex === index ? (
                                                <Autocomplete
                                                    sx={{ width: 500 }}
                                                    freeSolo
                                                    size="small"
                                                    options={messageValues}
                                                    defaultValue={messageValues[selectedIndex] ?? ''}
                                                    onChange={(event, newValue) => {
                                                        if (typeof newValue === 'string') {
                                                            inputRef.value = newValue;
                                                        }
                                                        commitAutocompleteEdit();
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            inputRef={(ref) => { inputRef = ref; }}
                                                            variant="outlined"
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    commitAutocompleteEdit();
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            ) : (
                                                <Typography variant="body1" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{messageValues[selectedIndex]}</Typography>
                                            )}
                                        </Box>}

                                        {ofType === OPTION_FACT_TYPE_IMAGE &&
                                            <ImageSelector layout={IMAGE_SELECTOR_IN_QUIZ_QUESTION} imd={of?.ofqo?.imd} lockAspect={LOCK_ASPECT_QUESTION} onAltChange={handleAltChange} onSelect={handleImageSelected} ></ImageSelector>

                                        }

                                        {ofType === OPTION_FACT_TYPE_AUDIO && (() => {
                                            const arg = of.ofqo?.messageArgs?.[0] || '';
                                            const audioUrl = arg.substring(2, arg.indexOf('>>'));
                                            const label = arg.substring(arg.indexOf('>>') + 2);

                                            return (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

                                                    <AudioPlayer audioUrl={audioUrl} />

                                                    <Typography variant="body1">{label}</Typography>
                                                </Box>
                                            );
                                        })()}
                                        <Box sx={{ display: 'flex', gap: 0.5, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                            <IconButton size="small" onClick={() => handleMove(index, -1)} disabled={index === 0}><ArrowUpwardIcon fontSize="small" /></IconButton>
                                            <IconButton size="small" onClick={() => handleMove(index, 1)} disabled={index === selectedList.length - 1}><ArrowDownwardIcon fontSize="small" /></IconButton>
                                            <IconButton size="small" onClick={() => handleEditClick(index)}><EditIcon fontSize="small" /></IconButton>
                                            <IconButton size="small" onClick={() => handleDelete(index)}><DeleteIcon fontSize="small" /></IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box sx={{ pl: '30px' }}>
                                    {editingIndex === index && (!of.ofqo?.messageKey) && (entity1 && entity2) ? (
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                value={of.ofqo?.correctOption?.qv?.quizzlerObject?.idMapping?.[qvSource] || ''}
                                                onChange={(event) => {
                                                    const selectedId = event.target.value;
                                                    const correctEntity = [entity1, entity2].find(ent => ent?.quizzlerObject.idMapping?.[qvSource] === selectedId);
                                                    if (correctEntity) {
                                                        const updated = [...selectedList];
                                                        updated[index] = {
                                                            ...updated[index],
                                                            ofqo: {
                                                                ...updated[index].ofqo,
                                                                correctOption: {
                                                                    qv: {
                                                                        quizzlerObject: {
                                                                            label: correctEntity.label,
                                                                            idMapping: correctEntity.quizzlerObject.idMapping
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        };
                                                        onUpdateSelectedList(updated);
                                                    }
                                                }}
                                            >
                                                <FormControlLabel value={entity1?.quizzlerObject.idMapping?.[qvSource]} control={<Radio size="small" />} label={<Typography variant="caption">{entity1?.label}</Typography>} />
                                                <FormControlLabel value={entity2?.quizzlerObject.idMapping?.[qvSource]} control={<Radio size="small" />} label={<Typography variant="caption">{entity2?.label}</Typography>} />
                                            </RadioGroup>
                                        </FormControl>
                                    ) : null}
                                    {(of.ofqo?.messageKey || editingIndex !== index) && (
                                        <Typography variant="caption" sx={{ color: 'green', fontWeight: 700 }}>{of.ofqo?.correctOption?.qv?.quizzlerObject?.label || of.ofqo?.correctOption?.qv?.label || ''}</Typography>
                                    )}
                                </Box>
                            </Box>
                        </ClickAwayListener>
                    </Box>
                );
            })}
        </Box>
    );
}